import FieldDefs from './ConcurentsFieldDefs'
import {doLangFields} from '../../lib/ks-tools'
import {Listeners} from "../../constants/listeners";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data () {
        return {
            fields: doLangFields(this, "lang.report.concurents.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'cnt',
                    direction: 'desc'
                }
            ],
            moreParams: {},
            viewMode: 0,
            selectedTop: 10,
            options: [
                {label: this.$t('lang.report.concurents.organic'), value: 0},
                {label: this.$t('lang.report.concurents.context'), value: 1},
            ],
        }
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        db: {
            type: String,
            required: true
        },
        top: {
            type: Number,
            required: true
        },
    },
    mounted () {
        let self = this
        this.initFields();
        this.$emitter.on(Listeners.KS_TOP_CHANGE, function (eventData) {
            self.selectedTop = eventData.top
            const url = new URL(window.location.href);
            url.searchParams.set("top", eventData.top);
            window.history.replaceState({}, "", url);
        });
    },
    created() {
        this.selectedTop = this.top;
    },
    computed: {
        self() {
            return this;
        },
        getApiUrl() {
            return '/report/simple/organic/concurents?base=' + this.db + '&domain=' + this.domain + '&top=' + this.selectedTop;
        }
    },
    methods: {
        initFields () {
            let self = this;
            self.fields.forEach((f) =>{
                if(f.hasOwnProperty('visibleRule')){
                    f.visible = eval(f.visibleRule);
                }
            });
            this.$emitter.emit(Listeners.KS_TABLE_NORMALIZE_FIELDS);
        },
    },
    watch: {
        viewMode: function(val){
            this.initFields();
        },
    },
}
